import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { useEffect, useState } from "react"
import axios from "axios"
import { get_date_dropdown } from "../../api/api"


const FilterReportDate = ({ dateValFrom, dateValTo, defaultdateValFrom = '', defaultdateValTo = '', dateSelect, defaultSelectedDate = 1 }) => {


    const [dropDown, setDropDown] = useState(null)
    const [isLoading, setIsLoading] = useState(false)


    const handleChangeDateFrom = (value) => {
        if (value) {
            let year = value.year
            let month = (value.month < 10 ? '0' + value.month : value.month)
            let day = (value.day < 10 ? '0' + value.day : value.day)
            let date = year + '-' + month + '-' + day
            dateValFrom(date)
        }
    }

    const handleChangeDateTo = (value) => {
        if (value) {
            let year = value.year
            let month = (value.month < 10 ? '0' + value.month : value.month)
            let day = (value.day < 10 ? '0' + value.day : value.day)
            let date = year + '-' + month + '-' + day
            dateValTo(date)
        }
    }


    useEffect(() => {
        const getDropDown = async () => {
            try {
                setIsLoading(true)
                const res = await axios.get(get_date_dropdown())
                setDropDown(res.data)
            } finally {
                setIsLoading(false)
            }
        }
        getDropDown()
    }, []);


    return (!isLoading &&
        <>
            <div className="flexRow">
                <select className="whiteBoy" id="dateType" onChange={(e) => dateSelect(e.target.value)} value={defaultSelectedDate}>
                    {dropDown && dropDown.map(item => (
                        <option key={item.id} value={item.id}>{item.title}</option>
                    ))}
                    <option value='3'>تاریخ دلخواه</option>
                </select>
            </div>

            {defaultSelectedDate === '3' && (<>
                <div className="flexRow">
                    <DatePicker
                        onOpenPickNewDate={false}
                        value={defaultdateValFrom}
                        format="YYYY/MM/DD"
                        placeholder='از تاریخ'
                        calendar={persian}
                        locale={persian_fa}
                        onChange={handleChangeDateFrom}
                        calendarPosition="bottom-right"
                    />
                </div>
                <div className="flexRow">
                    <DatePicker
                        onOpenPickNewDate={false}
                        value={defaultdateValTo}
                        format="YYYY/MM/DD"
                        placeholder='تا تاریخ'
                        calendar={persian}
                        locale={persian_fa}
                        onChange={handleChangeDateTo}
                        calendarPosition="bottom-right"
                    />
                </div>
            </>)}
        </>
    );
}

export default FilterReportDate;